import css from '@emotion/css/macro'
import { keyframes } from '@emotion/react'
import { isCanlan } from '@sportninja/common/utils/customer-name'

export const backgroundColor = '#181A1D'
export const backgroundColorRgb = '24, 26, 29'
export const backgroundColorLight = '#282E38'
export const borderColor = 'rgba(255, 255, 255, 0.1)'
export const border = `1px solid ${borderColor};`
export const cardColor = 'rgba(255, 255, 255, 0.05)'
export const flairColor = isCanlan ? '#004fff' : '#FFA300'
export const flairColorLight = isCanlan ? '#007fff' : '#FEE84E'
export const flairColorRgb = isCanlan ? '0, 79, 255' : '255, 163, 0'
export const flairColorLightRgb = isCanlan ? '79, 134, 255' : '254, 232, 78'
export const textColor = {
  grey: '#A5A5A6',
}

const sportninjaFont = {
  title: css`
    font-family: 'Rift', Arial, Helvetica, sans-serif;
  `,
  body: css`
    font-family: 'MaisonNeue', Arial, Helvetica, sans-serif;
  `,
}

const canlanFont = {
  title: css`
    font-family: 'Neue Plak Condensed', Arial, Helvetica, sans-serif;
    text-transform: uppercase;
    letter-spacing: 2px;
  `,
  body: css`
    font-family: 'Gilroy', Arial, Helvetica, sans-serif;
  `,
}

export const font = isCanlan ? canlanFont : sportninjaFont

export const errorColor = 'red'

export let MENU_HEIGHT = 50
export const setMenuHeight = (newHeight) => {
  MENU_HEIGHT = newHeight
}
export const menuHeight = `${MENU_HEIGHT}px`

export const linkStyle = css`
  text-decoration: underline;
  cursor: pointer;
`

// z-indexes begin at 1000 because of react-leaflet :(
const Z_INDEX_BASE = 1000
export const zIndex = {
  base: Z_INDEX_BASE,
  menu: Z_INDEX_BASE + 10,
  header: Z_INDEX_BASE + 20,
  overlay: Z_INDEX_BASE + 30,
  modal: Z_INDEX_BASE + 40,
}

const loader = keyframes`
  from { transform: rotate(0deg);   }
  to   { transform: rotate(359deg); }
`

export const loadingSpinner = css`
  color: transparent !important;
  cursor: default;
  position: relative;

  &:after {
    position: absolute;
    content: '';
    height: 1em;
    width: 1em;
    left: calc(50% - (1em / 2));
    top: calc(50% - (1em / 2));

    border: 2px rgba(${flairColorRgb}, 0.25) solid;
    border-top: 2px rgba(${flairColorRgb}, 1) solid;
    border-radius: 50%;
    animation: ${loader} 800ms infinite linear;
  }
`

export const downArrowCss = css`
  position: absolute;
  right: 12px;
  top: calc(50% - 3px);
  font-size: 10px;
  pointer-events: none;
  color: rgba(255, 255, 255, 0.8);
  *:hover ~ & {
    color: unset;
  }
`
